import React from 'react';

type Props = {
  children: React.ReactNode;
  enableDev?: boolean;
  enableStaging?: boolean;
  enableProd?: boolean;
};
const BuildMode = process.env.REACT_APP_BUILD_ENV || 'development';

class DevelopmentComponent extends React.Component<Props, {}> {

  render(): React.ReactNode {
    const {
      children, enableDev = true, enableStaging, enableProd,
    } = this.props;

    if (BuildMode === 'development' && enableDev) {
      return children;
    }
    if (BuildMode === 'staging' && enableStaging) {
      return children;
    }
    if (BuildMode === 'production' && enableProd) {
      return children;
    }
    return null;
  }
}

export default DevelopmentComponent;
